import styled from 'styled-components'
import theme from '../../styled/theme'

export const PaginationContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin-top: 32px;
  	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		justify-content: space-evenly;
	}
`

export const ArrowButton = styled.button`
	width: 25px;
	height: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	background: transparent;
	cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
	opacity: ${props => (props.disabled ? 0.3 : 1)};
	&:disabled {
		pointer-events: none;
	}
`

export const PageButton = styled.button`
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: none;
	background-color: ${props =>
		props.$isActive ? props.theme.colors.brand.blueOmint : 'transparent'};
	color: ${props =>
		props.$isActive ? props.theme.colors.brand.white : props.theme.colors.text.primaryText};
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;
	display: flex;
	align-items: center;
	justify-content: center;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		justify-content: space-evenly;
		font-size: 18px;
	}
`

export const Ellipsis = styled.span`
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${props => props.theme.colors.text.primaryText};
	font-size: 16px;
`
